module.exports = __webpack_public_path__ + "svg/loan.d3ce9fee4a07d1fa2c8d61492e2ed0fd.svg";